import { createAppConnector } from '@1hive/connect-core';
import Agreement from './models/Agreement';
import AgreementConnectorTheGraph, { subgraphUrlFromChainId, } from './thegraph/connector';
export default createAppConnector(async ({ app, config, connector, network, orgConnector, verbose }) => {
    var _a, _b, _c, _d, _e;
    if (connector !== 'thegraph') {
        console.warn(`Connector unsupported: ${connector}. Using "thegraph" instead.`);
    }
    const subgraphUrl = (_b = (_a = config.subgraphUrl) !== null && _a !== void 0 ? _a : subgraphUrlFromChainId(network.chainId)) !== null && _b !== void 0 ? _b : undefined;
    let pollInterval;
    if (orgConnector.name === 'thegraph') {
        pollInterval = (_e = (_c = config === null || config === void 0 ? void 0 : config.pollInterval) !== null && _c !== void 0 ? _c : (_d = orgConnector.config) === null || _d === void 0 ? void 0 : _d.pollInterval) !== null && _e !== void 0 ? _e : undefined;
    }
    const connectorTheGraph = await AgreementConnectorTheGraph.create({
        appAddress: app.address,
        pollInterval,
        subgraphUrl,
        verbose,
    });
    return new Agreement(connectorTheGraph, app);
});
